import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import { subHours } from 'date-fns' // TODO: remove

let state = {
  addEventDialog: false,
  closeEventDialog: false,
  eventDutiesDialog: false,
  eventPartnersDialog: false,
  eventTranslatorsDialog: false,
  eventPageLayouts: ['1', '1-1', '2-1', '2-2', '1-2-1'],
  eventPageLayout: '1-1',
  eventPageLayoutSizes: {
    topLeft: 50,
    topRight: 50,
    left: 50
  },
  eventsCurrentManagers: {},
  showAllEvents: false,
  eventIdsToShow: [],
  isCyclingMode: false,
  currentEventIndex: 0,
  cyclingInterval: null,
  partnersForAllEvents: null,
  translatorsForAllEvents: null,
  // eventsMapCenters: {}
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/events/index.js